import styled from 'styled-components';
import { cssUnit, FONT_COLOURS, shouldForwardProp, SPACES } from '@belong/themes';
import { Icon } from '../../Icon/Icon';
import { Copy } from '../../styles/Typography/Copy';

type StyledErrorProps = {
  onDarkBG: boolean;
};

export const StyledError = styled(Copy)
  .withConfig({
    shouldForwardProp: shouldForwardProp<StyledErrorProps>('onDarkBG')
  })
  .attrs<StyledErrorProps>(props => ({
    isBold: false,
    variant: 'medium',
    as: 'div',
    hasColor: props.onDarkBG ? FONT_COLOURS.ERROR_ON_DARK : FONT_COLOURS.ERROR
  }))<StyledErrorProps>`
  display: flex;
  align-items: center;
`;

export const StyledIcon = styled(Icon)`
  margin-right: ${SPACES.xsmall}${cssUnit};
  display: block;
`;
